import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useLoader } from "../../Loader";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";

function AddOthersForm(props) {
  const { startLoader, stopLoader } = useLoader();
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({
    otherName: "",
    state: "",
    district: "",
    city: null,
    subject: "",
    subjectDetails: "",
    contactName: "",
    contactNo: "",
    employees: [],
    totalAmount: "",
  });

  const [validated, setValidated] = useState(false);
  const [allEmployees, setAllEmployees] = useState([]);

  useEffect(() => {
    fetchAllEmployees();
    fetchStates();
  }, []);

  useEffect(() => {
    if (formData.state) {
      fetchDistricts(formData.state);
    }
  }, [formData?.state]);

  useEffect(() => {
    if (formData.district) {
      fetchCities(formData.district);
    }
  }, [formData?.district]);

  const fetchStates = () => {
    startLoader();
    utils
      .callAPI("get", `/state/list`)
      .then((res) => {
        setStates(res || []);
        stopLoader();
      })
      .catch(() => {
        setStates([]);
        stopLoader();
      });
  };

  const fetchDistricts = (stateId) => {
    startLoader();
    utils
      .callAPI("get", `/district/list?stateId=${stateId}`) // API to fetch districts
      .then((res) => {
        const data = Array.isArray(res) ? res : [];
        setDistricts(data);
        stopLoader();
      })
      .catch(() => {
        setDistricts([]);
        stopLoader();
      });
  };

  const fetchCities = (districtId) => {
    startLoader();
    utils
      .callAPI("get", `/city/by-district-list?districtId=${districtId}`) // API to fetch cities by district
      .then((res) => {
        const data = Array.isArray(res) ? res : [];
        setCities(data);
        stopLoader();
      })
      .catch(() => {
        setCities([]);
        stopLoader();
      });
  };

  const fetchAllEmployees = () => {
    startLoader();
    utils
      .callAPI("get", `/employee/list`)
      .then((res) => {
        setAllEmployees(
          (res?.result || []).map((emp) => ({
            value: emp.id,
            label: `${emp.firstName} ${emp.lastName}`,
          }))
        );
        stopLoader();
      })
      .catch(() => {
        setAllEmployees([]);
        stopLoader();
      });
  };

  const handleCityChange = (selectedOption) => {
    setFormData({ ...formData, city: selectedOption });
  };

  const handleCreateCity = (inputValue) => {
    const bodyFormData = new FormData();
    bodyFormData.append("state", formData.state);
    bodyFormData.append("district", formData.district);
    bodyFormData.append("city_name", inputValue);

    const tempOption = { label: inputValue, value: inputValue };
    setCities([...cities, { city_name: inputValue, city_code: inputValue }]);
    setFormData({ ...formData, city: tempOption });

    utils
      .callAPI("post", "/travel/add-city", bodyFormData)
      .then((res) => {
        if (res && res.city_code) {
          const newOption = { label: inputValue, value: res.city_code };
          const updatedCities = cities.map((city) =>
            city.city_code === inputValue
              ? { city_name: inputValue, city_code: res.city_code }
              : city
          );
          setCities(updatedCities);
          setFormData({ ...formData, city: newOption });
        }
      })
      .catch((err) => console.error("Failed to create city:", err));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "totalAmount" || name === "contactNo") {
      const validatedValue = value.replace(/\D/g, "");
      setFormData({ ...formData, [name]: validatedValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      const bodyFormData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props?.rowData?.id);
      }
      bodyFormData.append("other_name", formData.otherName);
      bodyFormData.append("state", formData.state);
      bodyFormData.append("district", formData.district);
      bodyFormData.append("city", formData.city?.value);
      bodyFormData.append("subject", formData.subject);
      bodyFormData.append("subject_detail", formData.subjectDetails);
      bodyFormData.append("contact_name", formData.contactName);
      bodyFormData.append("contact_no", formData.contactNo);
      bodyFormData.append("total_amt", formData.totalAmount);

      bodyFormData.append(
        "counter_key_person",
        formData.employees.map((e) => e.value).join(",")
      );

      utils
        .callAPI("post", "/meeting/others/save", bodyFormData)
        .then((res) => {
          if (res) {
            props.onChange({ mode: "list" });
          }
        })
        .catch((err) => console.error(err));
    }
  };

  const handleBackClick = () => {
    props.onChange({ mode: "list" });
  };

  const handleEmployeeChange = (selectedOptions) => {
    setFormData({ ...formData, employees: selectedOptions || [] });
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      const data = props.rowData;

      setFormData({
        otherName: data.other_name || "",
        state: data.state || "",
        district: data.district || "",
        city: data.city ? { value: data.city, label: data.city_name } : null,
        subject: data.subject || "",
        subjectDetails: data.subject_detail || "",
        contactName: data.contact_name || "",
        contactNo: data.contact_no || "",
        totalAmount: data.total_amt || "",
        employees: (data.emp_details || []).map((emp) => ({
          value: emp.id,
          label: emp.full_name,
        })),
      });

      // Set city list with current city if not already present
      if (data.city && data.city_name) {
        setCities((prev) => {
          const exists = prev.some((c) => c.city_code === data.city);
          return exists
            ? prev
            : [...prev, { city_code: data.city, city_name: data.city_name }];
        });
      }

      // Set district list with current district if not already present
      if (data.district && data.district_name) {
        setDistricts((prev) => {
          const exists = prev.some((d) => d.district_code === data.district);
          return exists
            ? prev
            : [
                ...prev,
                {
                  district_code: data.district,
                  district_name: data.district_name,
                },
              ];
        });
      }

      // Set state list with current state if not already present
      if (data.state && data.state_name) {
        setStates((prev) => {
          const exists = prev.some((s) => s.state_code === data.state);
          return exists
            ? prev
            : [
                ...prev,
                {
                  state_code: data.state,
                  state_name: data.state_name,
                },
              ];
        });
      }
    }
  }, [props?.rowData]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header>
          <h4>{props.rowData ? "Edit" : "Add"} Others Request</h4>
          <div className="card-header-action">
            <button
              className="btn btn-underline me-2"
              onClick={handleBackClick}
            >
              Back
            </button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Other Name"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    type="text"
                    name="otherName"
                    placeholder="Enter Other Name (e.g., Tournament)"
                    value={formData.otherName}
                    onChange={handleInputChange}
                    required
                  />
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter Other Name.
                  </RB.Form.Control.Feedback>
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col md={6} className="mb-3">
                <RB.FloatingLabel
                  label="State"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Select
                    name="state"
                    value={formData.state}
                    className="form-control"
                    onChange={handleInputChange}
                  >
                    <option value="">Select State</option>
                    {states.map((state) => (
                      <option key={state.state_name} value={state.state_code}>
                        {state.state_name}
                      </option>
                    ))}
                  </RB.Form.Select>
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col md={6} className="mb-3">
                <RB.FloatingLabel
                  label="District"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Select
                    name="district"
                    value={formData.district}
                    className="form-control"
                    onChange={handleInputChange}
                  >
                    <option value="">Select District</option>
                    {districts?.map((district) => (
                      <option
                        key={district.district_code}
                        value={district.district_code}
                      >
                        {district.district_name}
                      </option>
                    ))}
                  </RB.Form.Select>
                </RB.FloatingLabel>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mt-4">
                  <CreatableSelect
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    isClearable
                    placeholder="Type or select a city"
                    value={formData.city}
                    onChange={handleCityChange}
                    onCreateOption={handleCreateCity}
                    options={cities.map((city) => ({
                      label: city.city_name,
                      value: city.city_code,
                    }))}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor: !formData.city
                          ? ""
                          : baseStyles.borderColor,
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                  {/* {!formData.city && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "0.875rem" }}
                    >
                      Please select a city.
                    </div>
                  )} */}
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Subject"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                  />
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter Subject.
                  </RB.Form.Control.Feedback>
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col md={12}>
                <RB.FloatingLabel
                  label="Subject Detail"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    as="textarea"
                    name="subjectDetails"
                    placeholder="Enter Subject Detail"
                    value={formData.subjectDetails}
                    onChange={handleInputChange}
                    required
                  />
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter Subject Detail.
                  </RB.Form.Control.Feedback>
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Contact Name"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    type="text"
                    name="contactName"
                    placeholder="Contact Name"
                    value={formData.contactName}
                    onChange={handleInputChange}
                    required
                  />
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter Contact Name.
                  </RB.Form.Control.Feedback>
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Contact No"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    type="text"
                    name="contactNo"
                    placeholder="Contact Number"
                    value={formData.contactNo}
                    onChange={handleInputChange}
                    required
                  />
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter valid Contact No.
                  </RB.Form.Control.Feedback>
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col md={12} className="mt-4">
                <Select
                  isMulti
                  name="employees"
                  value={formData.employees}
                  onChange={handleEmployeeChange}
                  options={allEmployees}
                  placeholder="Select Employees"
                  className="bom-productName-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor:
                        formData.employees.length === 0 ? "" : base.borderColor,
                    }),
                  }}
                />
                {/* {formData.employees.length === 0 && (
                  <div
                    className="text-danger mt-1"
                    style={{ fontSize: "0.875rem" }}
                  >
                    Please select at least one employee.
                  </div>
                )} */}
              </RB.Col>

              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Total Amount"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    type="text"
                    name="totalAmount"
                    placeholder="Enter Amount"
                    value={formData.totalAmount}
                    onChange={handleInputChange}
                    required
                  />
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter Total Amount.
                  </RB.Form.Control.Feedback>
                </RB.FloatingLabel>
              </RB.Col>
            </RB.Row>

            <RB.Row className="mt-4">
              <RB.Col>
                <RB.Button type="submit" variant="primary">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default AddOthersForm;
